import './demo-component.css'

export default
function (ngModule) {
    ngModule.directive('demoComponent', () => {
        return {
            restrict: 'E',
            template: require('./demo-component.html')
        }
    })
}



// WEBPACK FOOTER //
// ./source/components/demo-component/demo-component.js